/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_ActiveInputs */

const en_user_active = /** @type {(inputs: User_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

const ja_user_active = /** @type {(inputs: User_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有効`)
};

const fr_user_active = /** @type {(inputs: User_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actif`)
};

const de_user_active = /** @type {(inputs: User_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiv`)
};

/**
* | output |
* | --- |
* | "Active" |
*
* @param {User_ActiveInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const user_active = /** @type {((inputs?: User_ActiveInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_ActiveInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_active(inputs)
	if (locale === "ja") return ja_user_active(inputs)
	if (locale === "fr") return fr_user_active(inputs)
	return de_user_active(inputs)
});